export { tekstid };

let get_hostname, parseLists;

const tekstid = () => {
    if (MODULE_NAME === "tekstid") {
        get_hostname = function(url) {
            var m = url.match(/^https?:\/\/([^:/]+)/);
            return m ? m[1] : null;
        }
    
        parseLists = function($ul) {
            var found = 0,
                $li,
                $a,
                host,
                cls,
                $icon,
                total = 0;
            $ul.children().each(function () {
                total++;
                $li = $(this);
                $li.find("a").each(function () {
                    $a = $(this);
                    host = get_hostname($a.prop("href"));
                    if (WWW_HOST == host) {
                        cls = "article";
                    } else {
                        cls = "link";
                    }
                    cls += " icon";
                    $icon = $("<span />").addClass(cls);
                    $a.prepend($icon);
                    found++;
                });
            });
            if (found > 0 && found == total) {
                $ul.addClass("file-list");
            }
        }
    
        $(".content-wrapper").find("ul").each(function () {
            parseLists($(this));
        });
        $(".content-wrapper").find("ol").each(function () {
            parseLists($(this));
        });
    }
}